import { ETableColumnAccessor } from './continuous';
export const TABLE_COLUMNS_DESCRIPTIONS = {
    [ETableColumnAccessor.Ancestry]: 'Ancestry',
    [ETableColumnAccessor.Variants]: 'Variant ID: Chromosome-GRCh38 coordinate (position)-reference allele-alternate allele',
    [ETableColumnAccessor.CollapsingModelName]: 'Collapsing model used to define qualifying variants. See global filters for model definitions',
    [ETableColumnAccessor.PValue]: 'P value from Fisher\'s Exact Test',
    [ETableColumnAccessor.YesQV]: 'Number of participants with a qualifying variant',
    [ETableColumnAccessor.NoQV]: 'Number of participants without a qualifying variant',
    [ETableColumnAccessor.CaseMedian]: 'Median of the Inverse Normal Transformation of the quantitative trait among participants with a qualifying variant',
    [ETableColumnAccessor.ControlMedian]: 'Median of the Inverse Normal Transformation of the quantitative trait among participants without a qualifying variant',
    [ETableColumnAccessor.Beta]: 'Estimated average difference in transformed outcome for QV carriers',
    [ETableColumnAccessor.BetaSTD]: 'Effect size standard error',
    [ETableColumnAccessor.LCI]: 'Lower limit of the 95% confidence interval for the effect size',
    [ETableColumnAccessor.UCI]: 'Upper limit of the 95% confidence interval for the effect size',
};
